export default __webpack_public_path__ + "cca62d21c8c555c392e580a52e0d4426.woff";